<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Forgot Password?
      </p>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <p>Provide your email address below and we'll send you an email with a link to reset your password.</p>
        <b-field label="Email / Username" horizontal
          :type="getFieldTypesFromValidationPath('email')"
          :message="getFieldMessages('email')">
          <b-input type="email" name="email" v-model.trim="$v.email.$model" :loading="$wait.is(forgotPasswordLoader)" :disabled="$wait.any" @input.native="set"></b-input>
        </b-field>
        <b-field label="" horizontal>
          <b-button type="is-primary" :loading="$wait.is(forgotPasswordLoader)" :disabled="! isForgotPasswordSubmittable" @click="sendForgotPasswordEmail"><i class="sl-mail-1"></i> Email Reset Password Link</b-button>
        </b-field>
      </div>
    </section>
    <footer class="modal-card-foot">
      &nbsp;
    </footer>
  </div>
</template>

<script>
import store from '@/store'
import { mapGetters, mapActions } from 'vuex'

import { validations, messages } from '@/plugins/vuelidate/validations/forgot-password-modal'

export default {
  data: function () {
    return {
      email: '',
      messages: messages,
      apiValidationErrors: {},
      forgotPasswordLoader: 'emailing password reset link'
    }
  },
  computed: {
    forgotPasswordPathSubset () {
      return ['email']
    },
    forgotPasswordPropertySubset () {
      return this.getPropertiesFromPaths(this.forgotPasswordPathSubset)
    },
    isForgotPasswordSubmittable () {
      return ! this.isSaving && this.isForgotPasswordDirty && ! this.forgotPasswordHasErrors
    },
    isForgotPasswordDirty () {
      return this.$v.email.$dirty
    },
    isSaving () {
      return this.$wait.any
    },
    forgotPasswordHasErrors () {
      return this.$v.$error
    },
  },
  validations: validations,
  methods: {
    ...mapActions([
      'sendPasswordResetLinkEmail'
    ]),
    set (e) {
      this.clearApiValidationFailures(e.target.name)
    },
    failedApiValidation (property) {
      return this.apiValidationErrors.hasOwnProperty(property)
    },
    clearApiValidationFailures (property) {
      if (this.apiValidationErrors.hasOwnProperty(property)) {
        delete this.apiValidationErrors[property]
      }
    },
    getFieldTypesFromValidationPath (validationPath) {
      return {
        'is-danger': eval(`this.$v.${ validationPath }.$error`)
      }
    },
    getFieldMessages(validationPath) {
      let validationPathArray = validationPath.split('.')
      return {...this.getFieldMessagesFromValidationPath(validationPath), ...this.getFieldMessagesFromFailedApiValidation(validationPathArray.pop())}
    },
    getFieldMessagesFromFailedApiValidation (property) {
      let fieldMessages = {}
      if (this.apiValidationErrors.hasOwnProperty(property)) {
        fieldMessages[this.apiValidationErrors[property]] = true
      }
      return fieldMessages
    },
    getFieldMessagesFromValidationPath (validationPath) {
      let validationPathArray = validationPath.split('.')
      let messages = this.messages

      while (validationPathArray.length) {
        messages = messages[validationPathArray.shift()]
      }

      let fieldMessages = {}

      for (const validation in messages) {
        fieldMessages[messages[validation]] = eval(`this.$v.${ validationPath }.$error && ! this.$v.${ validationPath }.${ validation }`)
      }

      return fieldMessages
    },
    toggleForgotPasswordModal (display) {
      this.isForgotPasswordModalActive = display
    },
    isValid (pathSubset) {
      let invalid = false
      for(const path of pathSubset) {
        eval(`this.$v.${ path }.$touch()`)
        invalid = invalid || eval(`this.$v.${ path }.$invalid`)
      }
      if (invalid) {
        this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Please fix the indicated fields'
        })
        return
      }
      return true
    },
    validate (pathSubset) {
      if (! this.isValid(pathSubset)) {
        this.$buefy.dialog.alert({
          type: 'is-danger',
          message: 'Please fix the indicated fields'
        })
        return
      }
      return true
    },
    async sendForgotPasswordEmail (e) {
      if (this.isValid(this.forgotPasswordPathSubset)) {
        this.$wait.start(this.forgotPasswordLoader)
        try {
          await this.sendPasswordResetLinkEmail({
            'email': this.email
          })
          this.$wait.end(this.forgotPasswordLoader)
          this.toggleForgotPasswordModal(false)
          this.$buefy.toast.open({
            message: 'An email was sent to you that contains a password reset link.',
            type: 'is-success',
            position: 'is-top',
            duration: 5000,
          })
        } catch (error) {
          console.log(error)
          this.$wait.end(this.forgotPasswordLoader)
          this.$buefy.dialog.alert({
            type: 'is-danger',
            title: 'Error',
            message: 'Unable to send password reset email. Please try again.',
          })
          return false
        }
      }
    }
  },
  validations: validations,
}
</script>

